'use client';

import { getCookie } from 'cookies-next';
type resCatIndex = {
  resId: string;
  url: string;
  cat: string;
};
const getFallbackCatUrl = (res_id: string) => {
  const cookieeKey = 'fallbackCatIndex';
  const existing = getCookie(cookieeKey);
  if (existing) {
    const orgReses: resCatIndex[] = JSON.parse(existing);
    const res = orgReses.find(res => res.resId == res_id);
    if (res) {
      return res.url;
    } else {
      return '';
    }
  }
  return '';
};
export default getFallbackCatUrl;